import { isLocalParticipantModerator } from '../../base/participants/functions';
import { connect } from '../../base/redux';

import AbstractMeetingCountdown from './AbstractMeetingCountDown';

/**
 * Meeting countdown until end time - Web implementation.
 */
class MeetingCountdown extends AbstractMeetingCountdown {

    /**
     * Implements React's render method.
     */
    render() {
        const { meetingEndTime, meetingTimezone } = this.props;
        const { timerValue } = this.state;
        const { default: renderConferenceTimer } = require('./ConferenceTimerDisplay');

        if (!meetingEndTime || !meetingTimezone) {
            return null;
        }

        return renderConferenceTimer(timerValue, true);
    }

}

/**
 * Maps Redux state to component props.
 */
function _mapStateToProps(state) {
    const end_time = state['features/base/jwt']?.meetingDetails?.end_time;
    const timezone = state['features/base/jwt']?.meetingDetails?.timezone;
    const { mhConferenceJoined, conferenceExpired, extendConferenceExpiry, conference } = state['features/base/conference'];
    const extendExpiry = state['features/base/jwt']?.meetingDetails?.settings?.EXTEND_EXPIRY;
    const isModerator = state['features/base/jwt']?.user?.moderator || isLocalParticipantModerator(state);
    const notifications = state['features/notifications'];


    return {
        meetingEndTime: end_time,
        meetingTimezone: timezone,
        conferenceExpired,
        extendExpiry: extendExpiry === 1,
        notifications,
        isModerator,
        extendTime: extendConferenceExpiry,
        conference,
        _mhConferenceJoined: mhConferenceJoined
    };
}

export default connect(_mapStateToProps)(MeetingCountdown);
